<template>
  <div class="procedure">
    <el-button class="fixed-back-btn" @click="$router.go(-1)">返回</el-button>
    <div class="left">
      <div class="top">
        <div class="topTitle">
          <img src="@static/images/liuc.png" alt="" />
          <span>预约跟进流程</span>
        </div>
        <div class="topbox">
          <div class="topContent">
            <div class="item active">
              <img src="@static/images/marketing/icon01a.png" class="active">
              <img src="@static/images/marketing/icon01.png" class="gray">
              <div class="word">待跟进</div>
            </div>
            <div class="item" :class="{active:leftData.status >= 11 || leftData.status == 81}">
              <img src="@static/images/marketing/icon02a.png" class="active">
              <img src="@static/images/marketing/icon02.png" class="gray">
              <div class="word">确认客户需求</div>
            </div>
            <div class="item" :class="{active:leftData.status >= 12 && leftData.status != 81}">
              <img src="@static/images/marketing/icon03a.png" class="active">
              <img src="@static/images/marketing/icon03.png" class="gray">
              <!-- <img v-else src="@static/images/procedure7.jpg" alt="" /> -->
              <div class="word">推荐合适产品</div>
            </div>
            <div class="item" :class="{active:leftData.status > 90 && leftData.status < 100}">
              <img src="@static/images/marketing/icon04a.png" class="active">
              <img src="@static/images/marketing/icon04.png" class="gray">
              <!-- <img
              
                src="@static/images/procedure4.png"
                alt=""
              />
              <img v-else src="@static/images/procedure8.jpg" alt="" /> -->
              <div class="word">跟进完成</div>
            </div>
          </div>
        </div>
      </div>
      <div class="yyDetail">
        <div class="topTitle">
          <img src="@static/images/yuyue.png" alt="" />
          <span>预约详情</span>
        </div>
        <div class="detailContent clearfix">
          <div class="topBox">
            <div class="going" v-if="leftData.status > 90 && leftData.status < 100">跟进完成</div>
            <div class="going" v-else-if="leftData.status == 1">待跟进</div>
            <div class="going" v-else>跟进中</div>
            <div class="right">
              <img src="@static/images/marketing/icon01a.png" class="active" v-if="leftData.status == 1">
              <img src="@static/images/marketing/icon02a.png" class="active" v-if="leftData.status == 11 || leftData.status == 81">
              <img src="@static/images/marketing/icon03a.png" class="active" v-if="leftData.status == 12">
              <img src="@static/images/marketing/icon04a.png" class="active" v-if="leftData.status > 90 && leftData.status < 100">
              <div>
                <div class="orderFlag" >
                  {{ all.SERVICE_STATUS[leftData.status] }}
                </div>
                <div class="zx" v-if="leftData.status != 81">
                  <span>跟进坐席：</span><span>{{ leftData.serverName }}</span>
                </div>
                <div class="zx" v-else>
                  <span>跟进坐席：</span><span>渠道跟进</span>
                </div>
              </div>
            </div>
          </div>
          <div class="botBox">
            <div class="left-info">
              <div class="leftItem" style="white-space: nowrap;">
                <span class="lab">预约时间</span>
                <span class="con">{{ leftData.consultTime }}</span>
              </div>
              <div class="leftItem" style="white-space: nowrap;">
                <span class="lab">创建时间</span>
                <span class="con">{{ leftData.createTime }}</span>
              </div>
              <div class="leftItem">
                <span class="lab">第几次预约</span>
                <span class="con">
                  {{ leftData.consultNum }} 
                </span>
              </div>
              <div class="leftItem">
                <span class="lab">累计预约次数</span>
                <span class="con">
                  {{ leftData.totalConsultNum }} 
                  <span class="btn" v-if="showDetailButton" @click="$refs.preOrderDetail.open(id)">查看详情 ></span>
                </span>
              </div>
              <div class="leftItem">
                <span class="lab">预约来源</span>
                <tooltip class="con" v-if="leftData.title" :txt-info="leftData.title"></tooltip>
                <!-- <tooltip class="con" v-else-if="productName" :txt-info="productName+'（'+leftData.sourceDesc+'）'"></tooltip> -->
                <tooltip class="con" v-else :txt-info="leftData.sourceDesc"></tooltip>
              </div>
              <div class="leftItem">
                <span class="lab">姓名</span>
                <span class="con">{{ leftData.name }}</span>
              </div>
              <div class="leftItem">
                <span class="lab">年龄</span>
                <span class="con">{{ leftData.age  }}</span>
              </div>
              <div class="leftItem" v-if="leftData.extInfo">
                <span class="lab">其他信息</span>
                <span class="con">{{leftData.extInfo}}</span>
              </div>
              <div class="leftItem">
                <span class="lab">职业</span>
                <span class="con">{{ leftData.occupation  }}</span>
              </div>
              <div class="leftItem" v-if="leftData.sex!=0">
                <span class="lab">性别</span>
                <span class="con">{{ leftData.sex == 1 ? "男" : "女" }}</span>
              </div>
              <div class="leftItem">
                <span class="lab">联系电话</span>
                <span class="con">{{ leftData.mobile }}</span>
              </div>
              <div class="leftItem" v-if="leftData.wechat">
                <span class="lab">微信号</span>
                <span class="con">{{ leftData.wechat }}</span>
              </div>
              <div class="leftItem" v-if="leftData.question">
                <span class="lab">核保问题</span>
                <span class="con">{{ leftData.question }}</span>
              </div>
              <div class="leftItem">
                <span class="lab">沟通方式</span>
                <span class="con">{{ leftData.lastType | filterLastType}}</span>
              </div>
              <div class="bottomItem">
                <span class="lab">描述</span>
                <span class="con">{{ leftData.lastContent }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div  class="right">
      <div class="record" v-if="leftData.status != 81">
        <div class="topTitle">
          <img src="@static/images/time.png" alt="" />
          <span>客户跟进记录</span>
        </div>
        <div class="recordBox">
          <div
            class="item"
            v-for="(item, index) in record"
            :key="index"
            :class="{ active: item.active }"
          >
            <div class="dian"></div>
            <div class="cbox clearfix">
              <div class="time">{{ item.createTime }}</div>
              <div class="content">
                <div class="title" v-if="item.status">
                  {{ item.status | recordTitle(item.serverName) }}
                </div>
                <div class="desc" v-if="item.content">
                  跟进记录：{{ item.content }}
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="dian"></div>
            <div class="cbox clearfix">
              <div class="time">{{ leftData.createTime }}</div>
              <div class="content">
                <div class="title">
                  坐席安排：专业坐席顾问{{ leftData.serverName }}
                </div>
                <div class="desc">跟进记录：待跟进</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <pre-order-detail ref="preOrderDetail"></pre-order-detail>
  </div>
</template>
<script>
import preOrderDetail from "./component/preOrderDetail";
import tooltip from "@/components/tooltip";
export default {
  data: () => ({
    id: "",
    leftData: {},
    all: {},
    record: [],
    productName: "",
    showDetailButton:false,
  }),
  components: {tooltip,preOrderDetail},
  created() {
    this.id = this.$route.query.id;
    this.productName = this.$route.query.productName;
    this.getState();
    this.subscribelist();
  },
  methods: {
    getState: function () {
      var that = this;
      this.$tools.getall(that.setAll);
    },
    setAll: function (data) {
      this.all = data;
      this.subscribeDetail();
    },
    subscribeDetail: function () {
      this.$http({
        url: "/master/subscribeService/detail",
        type: "put",
        params: {
          id: this.id,
        },
      }).then((res)=> {
        this.leftData = res.data;
        this.showDetailButton = res.showDetailButton
      });
    },
    subscribelist: function () {
      var that = this;
      this.$http({
        url: "/master/subscribeService/read/list",
        type: "put",
        params: {
          serviceId: that.id,
        },
      }).then(function (data) {
        that.record = data.data;
      });
    },
  },
  mounted() {},
  filters:{
    filterLastType(val){
      if(val==1){
        return '电话'
      }else if(val==2){
        return '微信'
      }
    }
  }
};
</script>
<style lang="scss">
@import "./procedure";
.procedure {
  display: flex;
  .left {
    display: flex;
    flex-direction: column;
    width: 55%;
  }
  .right {
    width: 45%;
    background: #fff;
  }
}
</style>
